import React from 'react';
import { Bar } from 'react-chartjs-2';

const BarChartVE = ({ sales, expenses }) => {
    const data = {
        labels: ['Ventas', 'Gastos'],
        datasets: [
            {
                data: [sales, expenses],
                backgroundColor: ['rgba(221, 51, 255, 0.6)', 'rgba(247, 94, 37, 0.6)'],
                borderWidth: 0,

            },
        ],
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true,
            },
        },
        plugins: {
            legend: {
                display: false,
            }
        }
    };

    return <Bar data={data} options={options} />;
};

export default BarChartVE;
